var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkmark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-arrow",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.9998008,0 C38.0376031,0 0,38.0376922 0,85 C0,131.962308 38.0376031,170 84.9998008,170 C131.961998,170 170,131.962706 170,85 C170,38.0372938 131.962397,0 84.9998008,0 Z M84.9998008,153.000239 C47.5148301,153.000239 16.9997211,122.485059 16.9997211,85 C16.9997211,47.5149414 47.5148301,17.0001594 84.9998008,17.0001594 C122.484771,17.0001594 152.99988,47.5149414 152.99988,85 C152.99988,122.485059 122.484771,153.000239 84.9998008,153.000239 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "checkmark"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask-Copy-2",
    fill: "#0A853D",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.59375,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "8.79540043 12.286517 15.4255096 5.65640783 16.309393 6.54029131 8.79638348 14.0533009 8.79540043 14.0523178 8.79441738 14.0533009 3.93305826 9.19194174 4.81694174 8.30805826"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.9c4f0314173524ca65823527d9ce56a5.svg";
export { ForwardRef as ReactComponent };